var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogueInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "headband__svg-catalogue",
    width: "20px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "3 4.00017372 21 4.00017372 21 19.162 3 19.162"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Catalogue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,15.0214 C17.669,14.9394 15.416,15.0614 13,16.3454 L13,7.6954 C15.461,6.0204 17.828,5.9224 19,6.0234 L19,15.0214 Z M5,15.0214 L5,6.0234 C6.17,5.9244 8.54,6.0224 11,7.6954 L11,16.3474 C8.953,15.2594 7.024,15.0004 5.672,15.0004 C5.429,15.0004 5.203,15.0084 5,15.0214 L5,15.0214 Z M20.242,4.1924 C20.068,4.1474 16.122,3.2084 12,5.9384 C7.879,3.2084 3.931,4.1464 3.758,4.1924 C3.312,4.3034 3,4.7034 3,5.1624 L3,16.1624 C3,16.4684 3.143,16.7564 3.383,16.9474 C3.624,17.1354 3.937,17.2064 4.238,17.1334 C4.384,17.0974 7.856,16.3044 11.4,18.9614 C11.441,18.9934 11.488,19.0074 11.533,19.0314 C11.571,19.0514 11.605,19.0754 11.647,19.0904 C11.762,19.1344 11.88,19.1624 12,19.1624 C12.12,19.1624 12.238,19.1344 12.353,19.0904 C12.395,19.0754 12.429,19.0514 12.467,19.0314 C12.512,19.0074 12.559,18.9934 12.6,18.9614 C16.143,16.3044 19.614,17.0984 19.758,17.1314 C20.057,17.2094 20.373,17.1394 20.615,16.9504 C20.858,16.7604 21,16.4694 21,16.1624 L21,5.1624 C21,4.7034 20.687,4.3034 20.242,4.1924 L20.242,4.1924 Z",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogueInverted);
export default __webpack_public_path__ + "static/media/catalogue-inverted.dc7fd354c7b06f04ec6f33102a381827.svg";
export { ForwardRef as ReactComponent };